// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__CgWn3","title":"styles_title__UkI-V"};